import React from 'react';
import Page from '../Containers/Page';

class SidebarPage extends React.Component {
    render() {
        return <Page title={this.props.title}>
            <div className="main-content">
                <div className="container">
                    <div className="row sidebar-row">
                        <div className="col-md-4">
                            {this.props.sidebar}
                        </div>
                        <div className="col-md-8">
                            <div className="content-wrapper">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    }
}

export default SidebarPage;


// WEBPACK FOOTER //
// ./src/components/Presentation/SidebarPage.js